<p-message *ngIf="showDummyData" severity="error"
    text="
You have not enabled order downloading from any sales channels yet. The dummy data shown below will be removed once you connect your marketplaces."></p-message>
<p-messages *ngIf="showIntergrationTip" severity="info">
    <ng-template pTemplate>
        <div>
            To add your sales channels and import product and sales data, go to&nbsp; <a
                style="text-decoration: underline" href="/#/intergrations">Administration -> Integrations</a>. &nbsp;
            <a style="text-decoration: underline" target="_blank"
                href="http://doc.dataleed.com/category/integrations/"><i class="fa fa-external-link"></i> Learn more
                ..</a>
        </div>
    </ng-template>
</p-messages>
<p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="onTabChange($event)">
    <p-tabPanel header="Today" >
        <div class="grid" *ngIf="activeTabIndex === 0">
            <div class="col-12">
                <app-stats-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-top-profitables-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-top-sellables-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-quadrant-performance-matrix [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Yesterday">
        <div class="grid" *ngIf="activeTabIndex === 1">
            <div class="col-12">
                <app-stats-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-top-profitables-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-top-sellables-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-quadrant-performance-matrix [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Last 7 Days">
        <div class="grid" *ngIf="activeTabIndex === 2">
            <div class="col-12">
                <app-stats-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-top-profitables-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-top-sellables-widget [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
            <div class="col-12 xl:col-6">
                <app-quadrant-performance-matrix [dateStart]="dateStart" [dateEnd]="dateEnd" />
            </div>
        </div>
    </p-tabPanel>
</p-tabView>
<div class="grid">
    <div class="col-12 xl:col-12">
        <app-daily-summary-widget />
        <!-- <app-latest-sales-widget/>
        <app-latest-price-sync-widget/> -->
    </div>
    <div class="col-12 xl:col-6">
        <app-inventory-snapshot-widget />
        <!-- <app-top-profitables-widget /> -->
    </div>
    <div class="col-12 xl:col-6">
        <app-purchase-history-stat />
        <!-- <app-top-profitables-widget /> -->
    </div>
    
</div>